import script from "./Inscription.vue?vue&type=script&setup=true&lang=js"
export * from "./Inscription.vue?vue&type=script&setup=true&lang=js"

import "./Inscription.vue?vue&type=style&index=0&id=deb55dfa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-deb55dfa"]])

export default __exports__